(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["editorial-experience"] && !Shopify.designMode) return;
  try {
    (() => {
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const observer = !reducedMotion.matches && 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('editorial-entered');
          observer.unobserve(entry.target);
        });
      }, { threshold: .08 })
    : null;

  function prepareReviewLinks(scope = document) {
    const current = new URL(location.href);
    const isReview = document.body.dataset.reviewMode === 'true';
    const preview = current.searchParams.get('preview_theme_id');
    const localizedRoot = (document.body.dataset.localizedRoot || '/').replace(/\/$/, '');
    const paths = {
      '/pages/sobre-la-autora': 'autora',
      '/pages/libros': 'libros',
      '/pages/contacto': 'contacto',
      '/blogs/relatos': 'relatos',
      '/blogs/noticias': 'noticias'
    };
    scope.querySelectorAll('a[href]').forEach(link => {
      const raw = link.getAttribute('href');
      if (!raw || raw.startsWith('#')) return;
      let url;
      try { url = new URL(raw, location.href); } catch { return; }
      if (url.origin !== location.origin) return;

      const unlocalizedPath = url.pathname.replace(/^\/(es|de|en|pt|pt-br)(?=\/|$)/, '') || '/';
      const view = paths[unlocalizedPath] || (unlocalizedPath.startsWith('/pages/libro-') ? unlocalizedPath.slice(7) : null);
      if (isReview && view) {
        url.pathname = localizedRoot + '/';
        url.searchParams.set('view', view);
      }
      if (isReview && preview) url.searchParams.set('preview_theme_id', preview);
      link.href = url.toString();
    });
    scope.querySelectorAll('.language-native-form').forEach(form => {
      form.querySelectorAll('input[name="return_to"]').forEach(input => {
        const destination = new URL(current.href);
        destination.searchParams.delete('locale');
        input.value = destination.pathname + destination.search + destination.hash;
      });
    });
  }

  function enhance(scope = document) {
    prepareReviewLinks(scope);
    if (observer) scope.querySelectorAll('[data-reveal]:not(.editorial-entered)').forEach(element => observer.observe(element));
  }

  document.addEventListener('shopify:section:load', event => enhance(event.target));
  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches && observer) {
      observer.disconnect();
      document.querySelectorAll('.editorial-entered').forEach(element => element.classList.remove('editorial-entered'));
    }
  });
  enhance();
  document.getElementById('ContactStatus')?.focus();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["theme-resources"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';

  const mobileBreakpoint = window.matchMedia('(max-width: 990px)');
  let navigationCleanup;

  function initializeNavigation() {
    if (navigationCleanup) navigationCleanup();
    const toggle = document.querySelector('.mobile-toggle');
    const navigation = toggle && document.getElementById(toggle.getAttribute('aria-controls') || 'MobileNavigation');
    if (!toggle || !navigation) return;

    const abortController = new AbortController();
    const options = { signal: abortController.signal };

    function setOpen(open, restoreFocus = false) {
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
      navigation.hidden = !open;
      document.body.classList.toggle('menu-open', open && mobileBreakpoint.matches);
      if (open) navigation.querySelector('a[href]')?.focus();
      if (!open && restoreFocus) toggle.focus();
    }

    function closeOnResize() {
      if (!mobileBreakpoint.matches) setOpen(false);
    }

    setOpen(false);
    toggle.addEventListener('click', () => setOpen(toggle.getAttribute('aria-expanded') !== 'true'), options);
    navigation.addEventListener('click', (event) => {
      const link = event.target.closest('a');
      if (link && link.getAttribute('aria-disabled') !== 'true') setOpen(false);
    }, options);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Tab' && toggle.getAttribute('aria-expanded') === 'true') {
        const links = Array.from(navigation.querySelectorAll('a[href], button:not([disabled])'));
        const first = links[0];
        const last = links[links.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); toggle.focus();
        } else if (event.shiftKey && document.activeElement === toggle) {
          event.preventDefault(); last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); toggle.focus();
        } else if (!event.shiftKey && document.activeElement === toggle) {
          event.preventDefault(); first?.focus();
        }
      }
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') setOpen(false, true);
    }, options);
    document.addEventListener('click', (event) => {
      if (toggle.getAttribute('aria-expanded') === 'true' && !navigation.contains(event.target) && !toggle.contains(event.target)) setOpen(false);
    }, options);
    mobileBreakpoint.addEventListener('change', closeOnResize);

    navigationCleanup = () => {
      setOpen(false);
      abortController.abort();
      mobileBreakpoint.removeEventListener('change', closeOnResize);
    };
  }

  function openLinkedBook(hash = window.location.hash) {
    let identifier;
    try { identifier = decodeURIComponent(hash.slice(1)); } catch { return; }
    if (!identifier) return;
    const target = document.getElementById(identifier);
    const book = target && (target.matches('details.book-detail') ? target : target.closest('details.book-detail'));
    if (book) book.open = true;
  }

  function setShareStatus(button, message) {
    const scope = button.closest('.article-footer') || button.parentElement;
    const status = scope && scope.querySelector('[data-share-status]');
    if (status) status.textContent = message;
  }

  async function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch {  }
    }
    const previousFocus = document.activeElement;
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.setAttribute('aria-hidden', 'true');
    textarea.style.cssText = 'position:fixed;top:0;left:-9999px;font-size:16px;';
    document.body.appendChild(textarea);
    textarea.select();
    let copied = false;
    try { copied = document.execCommand('copy'); } catch { copied = false; }
    textarea.remove();
    if (previousFocus instanceof HTMLElement) previousFocus.focus({ preventScroll: true });
    return copied;
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-share]');
    if (!button) return;
    event.preventDefault();
    const url = button.dataset.shareUrl || window.location.href;
    const title = button.dataset.shareTitle || document.title;
    setShareStatus(button, '');

    if (navigator.share) {
      try {
        await navigator.share({ title, url });
        return;
      } catch (error) {
        if (error && error.name === 'AbortError') return;
      }
    }

    const copied = await copyText(url);
    setShareStatus(button, copied ? 'Enlace copiado.' : 'Puedes copiar el enlace desde la barra de direcciones.');
  });

  document.addEventListener('click', (event) => {
    const disabledLink = event.target.closest('a[aria-disabled="true"]');
    if (disabledLink) event.preventDefault();
    const link = event.target.closest('a[href]');
    if (!link || disabledLink) return;
    let destination;
    try { destination = new URL(link.href, window.location.href); } catch { return; }
    if (destination.origin === window.location.origin && destination.pathname === window.location.pathname && destination.search === window.location.search && destination.hash) {
      openLinkedBook(destination.hash);
    }
  });

  window.addEventListener('hashchange', () => openLinkedBook());
  document.addEventListener('shopify:section:load', initializeNavigation);
  initializeNavigation();
  openLinkedBook();
})();
  } catch(e) { console.error(e); }
})();

})();
